import { Container } from "@material-ui/core";
import React from "react";
import { useParams } from "react-router-dom";
import useFetch from "../../../hooks/useFetch";
import Footer from "../../Shard/Footer/Footer";
import Header from "../../Shard/Navbar/Header";
import "./ArticleDetails.css";
const ArticleDetails = (shaw, setIsShaw) => {
  const { id } = useParams();
  const { data } = useFetch(
    `https://abc-backend.onrender.com/api/articles/${id}`
  );
  console.log(data);
  console.log(id);
  const AR = process.env.REACT_APP_PUBLIC_FOLDER;
  return (
    <div>
      <Header isShaw={shaw} setIsShaw={setIsShaw} />
      <div style={{ marginTop: "120px", height: "100vh" }}>
        <Container>
          <div className="aricleMain">
            <div className="article_left">
              <img src={AR + data.image} alt="article" />
            </div>
            <div className="article_right">
              <h2>{data?.title}</h2>
              <p>{data?.desc}</p>
            </div>
          </div>
        </Container>
      </div>
      <Footer />
    </div>
  );
};

export default ArticleDetails;
